import { Box, BoxProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCoverLevelOption, Quote } from '../../../domain'
import { useQuotePremiums } from '../../../hooks/premiums'
import { TKey } from '../../../infrastructure/internationalisation'
import { ProductConfig } from '../../../state/configuration'
import { StandardAdjustedPremium } from './StandardAdjustedPremium'

export interface AnnualAdjustedPremiumsProps extends BoxProps {
  currentQuote: Quote
  previousQuote?: Quote
  product: ProductConfig
  expanded?: boolean
}

const tKey = TKey('components.annual-adjusted-premium')

export const AnnualAdjustedPremium: FunctionComponent<AnnualAdjustedPremiumsProps> = ({
  currentQuote,
  previousQuote,
  product,
  expanded,
  ...props
}) => {
  const currentPremiums = useQuotePremiums(currentQuote, product)
  const previousPremiums = useQuotePremiums(previousQuote, product)

  const promotion = getCoverLevelOption(currentQuote)?.promotion

  return (
    <Box width={1} p={2} {...props}>
      <StandardAdjustedPremium
        currentPremiums={currentPremiums}
        previousPremiums={previousQuote && previousPremiums}
        promotion={promotion}
        expanded={expanded}
        tKey={tKey}
      />
    </Box>
  )
}
